module.exports = __webpack_public_path__ + "static/filemanager-5e24b6f4b900dd73727336735e6ef17e.jpg";